package screens.static

import common.ECssClasses
import components.Toolbar
import components.burgerMenu.BurgerMenu
import core.enums.ELocalizationKeys
import core.extensions.toClassName
import core.ionic.IonCol
import core.ionic.IonContent
import core.ionic.IonGrid
import core.ionic.IonHeader
import core.ionic.IonPage
import core.ionic.IonRow
import core.localization.Localization
import csstype.number
import csstype.px
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.span
import setUnsafeInnerHTML

external interface ShowIntegrityScreenProps: Props {}

val ShowIntegrityScreen = FC<ShowIntegrityScreenProps> {
    IonPage {
        //id = EConstants.BURGER_MENU_CONTENT.mId

        IonHeader {
            Toolbar{
                mIsBackNavigation = true
            }
        }
        IonContent {
            IonGrid {
                css(ECssClasses.VERTICAL_GRID.toClassName(), ECssClasses.NON_SCROLLABLE_GRID.toClassName()) {}
                IonRow {
                    css(ECssClasses.FULL_WIDTH_ROW.toClassName()) {
                        flexGrow = number(1.0)
                    }
                    IonCol {
                        css(ECssClasses.FULL_WIDTH_COL.toClassName()) {
                            marginTop = 12.px
                            marginLeft = 16.px
                            marginRight = 16.px
                        }
                        span {setUnsafeInnerHTML(Localization.getLocalizationKey(ELocalizationKeys.INTEGRITY_CONTENT.name))}
                    }
                }
            }
        }
    }
    BurgerMenu()
}